import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Header, Segment, Button, Loader, Message } from "semantic-ui-react";
import { getAuthToken, getClientAud } from "../selectors";

export default function AccountSubscriptions() {
  const authToken = useSelector(getAuthToken);
  const clientAud = useSelector(getClientAud);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [details, setDetails] = useState(null);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  useEffect(() => {
    async function load() {
      try {
        setLoading(true);
        const res = await fetch("/api/v1/subscriptions/details", {
          headers: authToken ? {
            "Authorization": `Bearer ${authToken}`,
            "JWT_AUD": clientAud,
          } : {},
          credentials: "include",
        });
        if (res.status === 401) {
          window.location.href = "/login";
          return;
        }
        if (!res.ok) throw new Error(`Fehler beim Laden (${res.status})`);
        const json = await res.json();
        if (mounted.current) setDetails(json);
      } catch (e) {
        if (mounted.current) setError(e.message);
      } finally {
        if (mounted.current) setLoading(false);
      }
    }
    load();
  }, [authToken, clientAud]);

  async function openPortal() {
    try {
      const res = await fetch("/api/v1/subscriptions/portal", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(authToken ? {
            "Authorization": `Bearer ${authToken}`,
            "JWT_AUD": clientAud,
          } : {}),
        },
        credentials: "include",
      });
      if (res.status === 401) {
        window.location.href = "/login";
        return;
      }
      const json = await res.json();
      if (json.url) {
        window.location.href = json.url;
      } else if (json.error) {
        setError(json.message || "Fehler beim Öffnen des Kundenportals.");
      }
    } catch (e) {
      setError("Fehler beim Öffnen des Kundenportals.");
    }
  }

  return (
    <div className="container">
      <Header as="h2">Abonnement</Header>
      <Segment>
        {loading && <Loader active inline="centered" />}
        {error && <Message error content={error} />}
        {!loading && !error && (
          <>
            {details && details.active ? (
              <div style={{ marginBottom: 16 }}>
                <div><strong>Status:</strong> Aktiv</div>
                <div><strong>Laufzeit:</strong> {details.plan_interval_months} Monate</div>
                <div><strong>Preis:</strong> {(details.price_cents/100.0).toFixed(2)} {details.currency?.toUpperCase()}</div>
                {details.current_period_end && (
                  <div><strong>Läuft bis:</strong> {new Date(details.current_period_end).toLocaleDateString()}</div>
                )}
              </div>
            ) : (
              <div style={{ marginBottom: 16 }}>
                Kein aktives Abonnement vorhanden.
              </div>
            )}
            <div>
              <Button primary onClick={openPortal}>
                Abonnement verwalten (Upgrade/Kündigen/Rechnungen)
              </Button>
              {!details?.active && (
                <Button style={{ marginLeft: 8 }} onClick={() => { window.location.href = "/subscribe"; }}>
                  Jetzt abonnieren
                </Button>
              )}
            </div>
          </>
        )}
      </Segment>
    </div>
  );
}

